import { DateRange } from 'react-day-picker';
import { toZonedTime } from 'date-fns-tz';

const isValidDate = (date: Date | undefined): date is Date =>
  date instanceof Date && !isNaN(date.getTime());

export const utcDateRangeToZoned = (
  dateRange: DateRange | undefined,
  timeZone: string,
): DateRange | undefined => {
  if (!dateRange) {
    return undefined;
  }

  const from = isValidDate(dateRange.from)
    ? toZonedTime(dateRange.from, timeZone)
    : undefined;
  const to = isValidDate(dateRange.to)
    ? toZonedTime(dateRange.to, timeZone)
    : undefined;

  return { from, to };
};
